export const AthleteFields = Object.freeze({
  fullname: "fullname",
  fullname_no_link: "fullname_no_link",
  score_general: "score_general",
  score_trail: "score_trail",
  score_cross: "score_cross",
  score_off_stadium: "score_off_stadium",
  category: "category",
  firstname: "firstname",
  lastname: "lastname",
  gender: "gender",
  dob: "dob",
  department: "department",
  club: "club",
  club_no_link: "club_no_link",
  rank: "rank",
  action_assign_to_user: "action_assign_to_user",
  action_subscribe: "action_subscribe",
  action_add_to_group: "action_add_to_group",
});

export const AthleteFieldsLabels = Object.freeze({
  [AthleteFields.fullname]: "Nom",
  [AthleteFields.fullname_no_link]: "Nom",
  [AthleteFields.score_general]: "Score",
  [AthleteFields.score_trail]: "Sc. trail",
  [AthleteFields.score_cross]: "Sc. cross",
  [AthleteFields.score_off_stadium]: "Sc. hs. stade",

  [AthleteFields.category]: "Catégorie",
  [AthleteFields.firstname]: "Prénom",
  [AthleteFields.lastname]: "Nom",
  [AthleteFields.gender]: "Sexe",
  [AthleteFields.dob]: "Date de naissance",
  [AthleteFields.club]: "Club",
  [AthleteFields.club_no_link]: "Club",
  [AthleteFields.department]: "Dép.",
  [AthleteFields.rank]: "",
  [AthleteFields.action_assign_to_user]: "",
  [AthleteFields.action_add_to_group]: "",
});
